
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/activities/stock-rebate/invited",
      function () {
        return require("private-next-pages/activities/stock-rebate/invited.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/activities/stock-rebate/invited"])
      });
    }
  